import InvitedUser from './InvitedUser';

export default InvitedUser;
